import { createAction } from 'redux-actions';

export const setPlan = createAction('PRICE_PLANS/SET_PLAN', value => value);
export const setPlanObj = createAction('PRICE_PLANS/SET_PLAN_OBJ', value => value);
export const setPeriod = createAction('PRICE_PLANS/SET_PERIOD', value => value);
export const setPlansHeader = createAction('PRICE_PLANS/SET_PLANS_HEADER', value => value);
export const setPlansAccess = createAction('PRICE_PLANS/SET_PLANS_ACCESS', value => value);
